import type { AnySceneObjectT } from "tweenly"
import { selectUndoable } from "../../../helpers/selector.helpers"
import { useAppSelector } from "../../../hooks/useRedux"
import { useMasterTimeline } from "../../../hooks/useMasterTimeline"
import { selectSortedRootObjects } from "../../../store/slices/objects.slice"
import { calcTimelineRowWidth } from "../../../style/sizing"
import TimelineRows from "./Timeline/TimelineRows"
interface Props {
    size: { width: number }
}

const Timeline = ({ size }: Props) => {
    const objects: AnySceneObjectT[] = useAppSelector((state) =>
        selectSortedRootObjects(selectUndoable(state).objects)
    )
    const timelinePreferences = useAppSelector((state) => state.timelinePreferences.value)
    const timelineZoom: number = timelinePreferences.timelineZoom

    const { masterTimelineDuration } = useMasterTimeline()

    const timelineRowWidth: number = calcTimelineRowWidth(
        size.width,
        masterTimelineDuration,
        timelineZoom
    )

    return (
        <TimelineRows
            objects={objects}
            timelineRowWidth={timelineRowWidth}
            isHidingObject={false}
            isLockingObject={false}
        />
    )
}

export default Timeline
